module.exports = __webpack_public_path__ + "img/dashboarddocument.7c27b101.png";